module.exports = __webpack_public_path__ + "static/media/RedirectToMap.d29df933.svg";